import {
  ActiveInactiveStatus,
  ApiListRequest,
  ApiListResponse,
  MembershipBean,
  MembershipDurationType,
  MembershipSummaryDTO,
  MembershipType,
} from "@gymflow/types";
import {
  infiniteQueryOptions,
  QueryKey,
  queryOptions,
} from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["memberApiMembership"] as QueryKey,
  id: (id?: unknown) => [...keys.all(), "id", id] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
  summary: (params: unknown) => [...keys.all(), "summary", params] as QueryKey,
};

export const memberApiMembership = {
  keys,
  queries: {
    id: (id: number | undefined) =>
      queryOptions({
        queryKey: keys.id(id),
        queryFn: async () => {
          return (await api.get<MembershipBean>(`/customer/membership/${id}`))
            .data;
        },
        enabled: !!id,
      }),
    summary: (params: {
      membershipId: number;
      promotionCode?: string;
      startDate?: string;
    }) =>
      queryOptions({
        queryKey: keys.summary(params),
        queryFn: async () => {
          return (
            await api.get<MembershipSummaryDTO>(
              `/customer/membership-signup/summary`,
              { params },
            )
          ).data;
        },
      }),
  },
  infiniteQueries: {
    list: (
      params: {
        status?: ActiveInactiveStatus;
        id?: number[];
        type?: MembershipType;
        durationType?: MembershipDurationType[];
        isTrial?: boolean;
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.get<ApiListResponse<MembershipBean>>(
              `/customer/membership`,
              {
                params: { ...params, page: pageParam },
              },
            )
          ).data;
        },
        ...numberPagination,
      }),
  },
  mutations: {},
};
